import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, MaskLines } from "./Reveal";

export const Manifesto = () => {
  const { t } = useLang();
  const m = t.manifesto;

  return (
    <section id="about" data-testid="manifesto-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="spot-glow w-[400px] h-[400px] bg-[#D4AF37]/10 top-20 -left-32" />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-[#D4AF37] mb-6">
            {m.overline}
          </p>
        </Reveal>
        <h2 className="font-display font-medium tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02] max-w-3xl text-white">
          <MaskLines lines={[m.title]} />
        </h2>

        <div className="mt-16 sm:mt-20 grid md:grid-cols-2 gap-x-16 gap-y-14">
          {m.chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08}>
              <div className="group border-t border-white/10 pt-7 hover-lift">
                <div className="flex items-baseline gap-5">
                  <span className="font-mono text-sm text-[#D4AF37]">{c.n}</span>
                  <div>
                    <h3 className="font-display text-2xl sm:text-3xl font-semibold text-white group-hover:text-[#D4AF37] transition-colors">
                      {c.t}
                    </h3>
                    <p className="mt-3 text-zinc-400 leading-relaxed max-w-md">{c.d}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
